import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '100%',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '20px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    backgroundColor: theme.palette.background.paper,
  },
  sectionMuted: {
    opacity: 0.7,
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '96px minmax(220px, 360px) auto',
    gap: '12px',
    alignItems: 'center',
    width: 'fit-content',
    maxWidth: '100%',
  },
  sliderWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    maxWidth: '360px',
    paddingBottom: '14px',
  },
  probabilityRow: {
    display: 'grid',
    gridTemplateColumns: '96px minmax(180px, 260px) 1fr auto',
    gap: '12px',
    alignItems: 'center',
    width: '100%',
  },
  probabilityEditor: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  probabilityFieldGroup: {
    minWidth: 0,
    width: '60px',
    '& .MuiFormHelperText-root': {
      whiteSpace: 'normal',
      lineHeight: 1.4,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  probabilityInput: {
    width: '100%',
  },
  itemActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  itemCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '10px',
    backgroundColor: theme.palette.background.default,
  },
  addButton: {
    alignSelf: 'flex-start',
  },
  helperText: {
    color: theme.palette.text.secondary,
  },
  disabledNotice: {
    color: theme.palette.warning.main,
  },
  sectionHint: {
    color: theme.palette.text.secondary,
    marginTop: '-8px',
  },
  probabilitySummary: {
    color: theme.palette.text.secondary,
  },
  probabilitySummaryError: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
}));
